export const DOWNLOAD_PDF_REQUEST = 'DOWNLOAD_PDF_REQUEST';
export const DOWNLOAD_PDF_SUCCESS = 'DOWNLOAD_PDF_SUCCESS';
export const DOWNLOAD_PDF_FAILURE = 'DOWNLOAD_PDF_FAILURE';

export const BILL = 'BILL';
export const CLINICAL_NOTE = 'CLINICAL_NOTE';
export const PAYMENT_RECEIPT = 'PAYMENT_RECEIPT';
